
<p class="card-text" [innerHTML]=q.instruction> </p>
<p class="card-text" [innerHTML]=q.content> </p>